import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Formik, Form } from 'formik';
import DatePickerComponent from '../../global/date-picker-component';

import { generateYIRReport } from './actions';

const mapStateToProps = state => ({
  global: state.Global,
  booking: state.Booking
});


class ReportsComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      yir_isSubmitting: false,
      yir_showCalendar: false,

    }
    this.yirForm = React.createRef();
    this.onYIRSubmit = this.onYIRSubmit.bind(this);
    this.onYIRGenerated = this.onYIRGenerated.bind(this);
    this.onYIRToggleCalendar = this.onYIRToggleCalendar.bind(this);
    this.setYIRDates = this.setYIRDates.bind(this);
  }

  setYIRDates = (range) => {
    this.yirForm.current.setFieldValue("dates", range);

    if (range.from && range.to) {
      this.setState({ yir_showCalendar: false });
    }
  }

  resetYIRDates = () => {
    this.yirForm.current.setFieldValue("dates", { from: null, to: null });
  }

  onYIRToggleCalendar = () => {
    this.setState({ yir_showCalendar: !this.state.yir_showCalendar });
  }

  onYIRSubmit(values) {
    let { dispatch } = this.props;
    this.setState({ yir_isSubmitting: true });
    dispatch(generateYIRReport(values, this.onYIRGenerated));
  }

  onYIRGenerated() {
    this.setState({ yir_isSubmitting: false });
  }

  renderYIRDD(yir_isSubmitting, yir_showCalendar) {
    const submitText = yir_isSubmitting ? 'Generating...' : 'Generate';
    return (<Formik onSubmit={this.onYIRSubmit} initialValues={{ dates: { from: undefined, to: undefined } }} ref={this.yirForm}>
      {({ values }) => (
        <Form className="d-flex align-items-center">
          <div className={`date-picker-wrapper mr-1 ${yir_showCalendar ? 'active' : ''}`}>
            <div className="date-picker-label" onClick={this.onYIRToggleCalendar}>
              {!values.dates.from || !values.dates.to ? 'Select Date Range' : `${values.dates.from.toLocaleDateString()} - ${values.dates.to.toLocaleDateString()}`}
              <i className="far fa-calendar-alt"></i>
            </div>
            {yir_showCalendar &&
              <div className="date-picker">
                <DatePickerComponent selectedDates={values.dates} setDates={this.setYIRDates} noDisabledDates={true} />
                <div className="w-100 text-center pb-2 link"><span onClick={this.resetYIRDates}>Clear</span></div>
              </div>
            }
          </div>
          {(!values.dates.from || !values.dates.to || yir_isSubmitting)
            ? (<button className="btn btn-primary ml-3" type="submit" disabled={true}>
              {submitText}
            </button>)
            : (<button className="btn btn-primary ml-3" type="submit">Generate</button>)
          }
        </Form>
      )}
    </Formik>)
  }

  render() {
    let { isMobile } = this.props;
    let { yir_isSubmitting, yir_showCalendar } = this.state;
    return (<div className="container reports-container">
      <div className="row">
        <div className="col">
          {!isMobile && (<h2>Reports</h2>)}
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col d-flex flex-wrap align-items-center">
          <div className="">
            <h3>Owner Reports</h3>
          </div>
          <div className="ml-auto">
            {this.renderYIRDD(yir_isSubmitting, yir_showCalendar)}
          </div>
        </div>
      </div>
    </div>);
  }
}

export default withRouter(connect(mapStateToProps)(ReportsComponent));
